import { useCallback, useSyncExternalStore } from 'react';

const supportsMatchMedia = typeof window !== 'undefined' && 'matchMedia' in window;

/**
 * Subscribes to a CSS media query so layout decisions that can't live in CSS
 * (unmounting a subtree rather than hiding it) still react to orientation and
 * resize changes.
 */
export const useMediaQuery = (query: string): boolean => {
    const subscribe = useCallback((onStoreChange: () => void) => {
        if (!supportsMatchMedia) {
            return () => undefined;
        }

        const mediaQuery = window.matchMedia(query);
        mediaQuery.addEventListener('change', onStoreChange);

        return () => mediaQuery.removeEventListener('change', onStoreChange);
    }, [query]);

    const getSnapshot = useCallback(
        () => supportsMatchMedia && window.matchMedia(query).matches,
        [query]
    );

    return useSyncExternalStore(subscribe, getSnapshot, () => false);
};
